module.exports = __webpack_public_path__ + "static/media/Front-Upper-Arm(R) v2.e875b16d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front-Upper-Arm(R) v2.png
// module id = 412
// module chunks = 0